import { LogGroup, SetStyles, Log, now, Timing ,MyPIXIContainer } from "./MyHelpers";
import { ITimeout, Timeout } from "./Context/Timeout";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { Settings } from "./Settings";
import { SettingsEditor } from "./menu/MenuPages/SettingsPage";

export type MyVideoCallback = () => void;

export class MyVideoTimeCallback
{
    public time: number;
    public callback: MyVideoCallback;
}

export interface MyVideoParams
{
    resid: ResourceIdentifier;
    logGroup: LogGroup;
    src: string;

    style: Partial<CSSStyleDeclaration>;

    unloadOnEnd: boolean;
    unloadOnHide: boolean;
}

export interface MyVideoMeta
{
    loaded: boolean;
    duration: number;
    width: number;
    height: number;
}


let videos: MyVideo[] = [];
globalThis.videos = videos;


export function crashvideo()
{
    for (let video of videos)
    {
        (video.View() as HTMLVideoElement).src = "";
    }
}

globalThis.crashvideo = crashvideo

export class MyVideo
{
    protected readonly defaultParams: MyVideoParams = {
        resid: null,
        logGroup: null,
        src: null,

        style: null,

        unloadOnEnd: true,
        unloadOnHide: true,
    }

    protected readonly params: MyVideoParams;


    // does video exist on disk? to be able to load when needed
    protected exists: boolean = false;

    // video duration in milliseconds
    protected meta: MyVideoMeta = {
        loaded: false,
        duration: 0,
        width: 0,
        height: 0,
    };


    // is video loaded?
    protected loaded: boolean = false;
    protected playOnLoad: boolean = false;

    //
	protected video: HTMLVideoElement = null;
	
	//public static readonly EXTENSION: string = Settings.videoFormat;

    public constructor(params: Partial<MyVideoParams>)
    {

        videos.push(this);

        this.params = {...this.defaultParams, ...params};

        this.params.src += Settings.videoFormat;


        this.video = document.createElement("video");
        this.video.preload = "auto";
        this.video.classList.add(this.params.resid.ID());
        this.video.volume = 0;

        if (this.params.style)
        {
            SetStyles(this.video, this.params.style);
        }

        this.BindCallbacks();
    }

    private BindCallbacks()
    {
        this.video.onloadstart = () => this.OnLoadStart();
        //this.video.onloadend = () => this.OnLoadEnd();
        this.video.onload = () => this.OnLoad();
        this.video.onloadedmetadata = () => this.OnLoadMetaData();
        this.video.onloadeddata = () => this.OnLoadedData();

        this.video.oncanplay = () => this.OnCanPlay();
        this.video.oncanplaythrough = () => this.OnCanPlayTrough();
        this.video.onplay = () => this.OnPlay();
        this.video.onplaying = () => this.OnPlaying();
        this.video.onpause = () => this.OnPause();
        this.video.onseeking = () => this.OnSeeking();
        this.video.onseeked = () => this.OnSeeked();
        this.video.onsuspend = () => this.OnSuspend();
        this.video.onwaiting = () => this.OnWaiting();
        this.video.onended = () => this.OnEnded();
        this.video.onemptied = () => this.OnEmptied();
        this.video.onstalled = () => this.OnStalled();
        this.video.onerror = () => this.OnError();
    }

    public Name(): string
    {
        return this.params.resid.ID()
    }

    protected shouldLoadMetadata: boolean = false;
    protected loadingMetaData: boolean = false;
    public LoadMetaData(): void
    {
        Log.Debug(this.params.logGroup, "LoadMetaData()");
        this.shouldLoadMetadata = true;
        this.loadingMetaData = true;

        this.video.preload = "metadata";
        this.video.src = this.params.src;
        //this.video.load();
    }

    protected onMetaDataLoadedCallbacks: MyVideoCallback[] = [];
    public AddOnMetaDataLoadedCallback(callback: MyVideoCallback): void
    {
        this.onMetaDataLoadedCallbacks.push(callback);
    }

    protected onMetaDataErrorCallbacks: MyVideoCallback[] = [];
    public AddOnMetaDataErrorCallback(callback: MyVideoCallback): void
    {
        this.onMetaDataErrorCallbacks.push(callback);
    }

    protected OnLoadMetaData(): void
    {
        ////// Log.Debug(this.params.logGroup, "OnLoadMetaData");
        //console.log(`MyVideo mp4: ${this.Name()} OnLoadMetaData this.loaded: ${this.loaded}, this.loadingMetaData: ${this.loadingMetaData}`);
        Log.Debug(this.params.logGroup, "OnLoadMetaData()");
        if (this.loadingMetaData)
        {
            this.loadingMetaData = false;

            this.meta.loaded = true;
            this.meta.duration = this.video.duration * 1000;
            this.meta.width = this.video.videoWidth;
            this.meta.height = this.video.videoHeight;

            // unload video and reset preload to auto
            this.video.removeAttribute("src");
            this.video.load();
            this.video.preload = "auto";

            ////// Log.Debug(this.params.logGroup, "Metadata: " + JSON.stringify(this.meta));
            this.onMetaDataLoadedCallbacks.forEach((cb) => cb());
        }
        else
        {

        }
    }





    public Load(): void
    {
        Log.Debug(this.params.logGroup, "Load()");
        if (!this.loaded)
        {

            //this.loadingMetaData = this.shouldLoadMetadata;
            //// Log.Debug(this.params.logGroup, "Load()");

            this.video.src = this.params.src;
            this.video.load();


            if (this.loop)
            {
                this.video.loop = true;
            }
        }
        else
        {
            //// Log.Debug(this.params.logGroup, "Load() already loaded");
            // already loaded
        }
    }

    public Unload(): void
    {
        Log.Debug(this.params.logGroup, "Unload()");
        // //// Log.Debug(this.params.logGroup, "Unloading, currently loaded: " + this.loaded);
        // if (this.loaded)
        // {
        //     this.loaded = false;


        // }
        // else
        // {
        //     // already unloaded
        // }



        this.video.removeAttribute("src");
        this.video.load();

        this.loaded = false;
    }

    public Reload(): void
    {
        Log.Debug(this.params.logGroup, "Reload()");
        this.Unload();


        setTimeout(() => this.Load(), 500);
        //this.Load();
    }

    protected loopForMilliseconds: number = -1;
    protected loopTimer: ITimeout = null;
    protected firstPlay: boolean = false;
    protected loop: boolean = false;


    protected isPlaying: boolean = false;
    protected playStartTime: number = 0;

    protected owner: ResourceIdentifier


    public Play(owner: ResourceIdentifier): void
    {
        Log.Debug(this.params.logGroup, `Play()`);
        this.loop = false;
        this.InternalPlay(owner);
    }

    public InternalPlay(owner: ResourceIdentifier): void
    {
        Log.Debug(this.params.logGroup, `InternalPlay()`);


        this.owner = owner;

        if (!this.loaded)
        {
            this.playOnLoad = true;
            this.Load();
        }
        else
        {
            this.playOnLoad = false;
            this.firstPlay = true;
            this.video.loop = this.loop;

            // play from start
            if (this.video.currentTime != 0)
            {
                this.video.currentTime = 0;
            }

            this.isPlaying = true;
            this.playStartTime = now();
            this.timeDetectedNotPlaying = 0;
            this.video.play();
            this.OnPlayStart();
        }
    }

    public PlayLoop(owner: ResourceIdentifier, loopForMilliseconds: number = -1): void
    {
        Log.Debug(this.params.logGroup, `PlayLoop()`);

        this.loop = true;
        this.InternalPlay(owner);

        this.loopForMilliseconds = loopForMilliseconds;

        if (this.loopTimer != null) 
        {
            this.loopTimer.Stop();
        }

        if (this.loopForMilliseconds != -1)
        {
            this.loopTimer = new Timeout(this.params.resid.Add("looptimer"), () => this.LoopTimerTriggered(), this.loopForMilliseconds);
        }
    }

    public Stop()
    {
        Log.Debug(this.params.logGroup, "Stop()");
        this.playOnLoad = false;
        if (this.isPlaying)
        {
            if (this.loopTimer != null) 
            {
                this.loopTimer.Stop();
            }
            this.video.pause();
        }
    }

    protected LoopTimerTriggered(): void
    {
        Log.Debug(this.params.logGroup, "LoopTimerTriggered()");
        this.StopAndReset(this.owner);
    }

    public StopAndReset(owner: ResourceIdentifier, resetToBeginning: boolean = false): void
    {
        Log.Debug(this.params.logGroup, "StopAndReset()");
        this.playOnLoad = false;
        if (this.loaded)
        {
            this.video.pause();
            if (resetToBeginning)
            {
            this.video.currentTime = 0;
            }

            this.OnEnded();
        }
    }


    protected OnLoadStart(): void
    {
        Log.Debug(this.params.logGroup, "OnLoadStart()");
    }
    
    protected OnLoadEnd(): void
    {
        Log.Debug(this.params.logGroup, "OnLoadEnd()");
    }

    protected OnLoad(): void
    {
        Log.Debug(this.params.logGroup, "OnLoad()");
    }

    protected OnLoadedData(): void
    {
        Log.Debug(this.params.logGroup, "OnLoadedData()");
    }

    protected OnPlayStart(): void
    {
        Log.Debug(this.params.logGroup, "OnPlayStart()");
    }

    //protected onPlayCallbacks: MyVideoCallback[] = []; 
    protected onPlayCallbacks: Map<string, MyVideoCallback> = new Map<string, MyVideoCallback>();
    public AddOnPlayCallback(owner: ResourceIdentifier,  callback: MyVideoCallback)
    {
        this.onPlayCallbacks.set(owner.ID(), callback);
    }

    protected OnPlay(): void
    {
        Log.Debug(this.params.logGroup, "OnPlay()");
        //this.onPlayCallbacks.forEach((cb) => cb());
    }


    protected OnPlaying(): void
    {
        Log.Debug(this.params.logGroup, "OnPlaying()");

        // play gets triggered every time video continues, lets just trigger callbacks first time
        if (this.firstPlay)
        {
            this.firstPlay = false;

            if (this.owner)
            {
                let cb = this.onPlayCallbacks.get(this.owner.ID());
                if (cb) cb();
            }
        }
    }


    protected OnCanPlay(): void
    {
        Log.Debug(this.params.logGroup, "OnCanPlay()");
    }


    protected OnCanPlayTroughCallbacks: MyVideoCallback[] = [];
    public AddOnCanPlayTroughCallback(callback: MyVideoCallback): void
    {
        this.OnCanPlayTroughCallbacks.push(callback);
    }

    protected OnCanPlayTrough(): void
    {
        Log.Debug(this.params.logGroup, "OnCanPlayTrough()");
        this.loaded = true;
        this.OnCanPlayTroughCallbacks.forEach((cb) => cb());
        if (this.playOnLoad)
        {
            this.InternalPlay(this.owner);
        }
    }


    protected OnEndedCallbacks: Map<string, MyVideoCallback> = new Map<string, MyVideoCallback>();
    public AddOnEndedCallback(owner: ResourceIdentifier, callback: MyVideoCallback): void
    {
        this.OnEndedCallbacks.set(owner.ID(), callback);
    }

    protected OnEnded(): void
    {
        Log.Debug(this.params.logGroup, "OnEnded()");

        if (this.params.unloadOnEnd && !this.loop)
        {
            this.Unload();
        }

        if (this.owner)
        {
            let cb = this.OnEndedCallbacks.get(this.owner.ID());
            this.owner = null;
            if (cb) cb();
        }
    }

    protected OnEmptied(): void
    {
        Log.Debug(this.params.logGroup, "OnEmptied()");
    }

    protected OnStalled(): void
    {
        Log.Debug(this.params.logGroup, "OnStalled()");
    }

    protected OnPause(): void
    {
        Log.Debug(this.params.logGroup, "OnPause()");
    }

    protected OnSeeking(): void
    {
        Log.Debug(this.params.logGroup, "OnSeeking()");
    }

    protected OnSeeked(): void
    {
        Log.Debug(this.params.logGroup, "OnSeeked()");
    }

    protected OnSuspend(): void
    {
        Log.Debug(this.params.logGroup, "OnSuspend()");
    }

    protected OnWaiting(): void
    {
        Log.Debug(this.params.logGroup, "OnWaiting()");
    }

    protected OnError(): void
    {
        Log.Debug(this.params.logGroup, "OnError()");
        //console.log(`MyVideo mp4 load error: ${this.Name()} this.loadingMetaData=${this.loadingMetaData}`);
        if (this.loadingMetaData)
        {
            this.loadingMetaData = false;
            this.meta.loaded = false;
            this.onMetaDataErrorCallbacks.forEach((cb) => cb());
        }
        else
        {

        }
    }

    // protected timeCallbacks: MyVideoTimeCallback[] = [];
    // public AddTimeCallback(time: number, callback: MyVideoCallback): void
    // {
    //     this.timeCallbacks.push({
    //         time: time,
    //         callback: callback
    //     });
    // }

    // protected timeEndCallbacks: MyVideoTimeCallback[] = [];
    // public AddTimeEndCallback(time: number, callback: MyVideoCallback): void
    // {
    //     this.timeEndCallbacks.push({
    //         time: time,
    //         callback: callback
    //     });
    // }

    protected hidden: boolean = false;
    public Hide(): void
    {
        Log.Debug(this.params.logGroup, "Hide()");
        this.hidden = true;
        this.video.style.display = "none";

        if (this.isPlaying)
        {
            this.Stop();
        }
        
        if (this.params.unloadOnHide)
        {
            this.Unload();
        }
    }

    public Show(): void
    {
        Log.Debug(this.params.logGroup, "Show()");
        this.hidden = false;
        this.video.style.display = "";
    }

    public View(): HTMLElement
    {
        return this.video;
    }

    public Duration(): number
    {
        if (this.meta.loaded)
        {
            return this.meta.duration;
        }
        
        return 0;
    }


    protected isPlayingCheck: number = 0;
    protected timeDetectedNotPlaying: number = 0;
    public Update(): void
    {

        let n = now();
        if (this.isPlaying)
        {
            // give some breathing space in case we are loading still
            if (Timing.Timeouted(this.playStartTime, 3000, n))
            {
                let isActuallyPlaying: boolean = this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2;

                if (!isActuallyPlaying)
                {
                    // first time detected
                    if (this.timeDetectedNotPlaying == 0) 
                    {
                        //// Log.Debug(this.params.logGroup, "NOT PLAYING first time");
                        this.timeDetectedNotPlaying = n;
                    }
                    // second time not detected, with 100ms delay, recover
                    else if (Timing.Timeouted(this.timeDetectedNotPlaying, 100, n))
                    {
                        //// Log.Debug(this.params.logGroup, "NOT PLAYING second time, reloading...");
                        this.Reload();
                        this.video.play();

                        this.playStartTime = n;
                        this.timeDetectedNotPlaying = 0;
                    }
                }
                else
                {
                    //// Log.Debug(this.params.logGroup, "OK  PLAYING");
                    this.timeDetectedNotPlaying = 0;
                    this.playStartTime = n;
                }
            }
        }
        else
        {
            this.isPlayingCheck = 0;
        }
    }
}